<div class="p-4 md:p-6 max-w-3xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">upload_file</mat-icon>
      Carga Manual XLS BCI
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Selecciona una cuenta y sube un archivo Excel para procesar transacciones.
    </p>
  </div>

  <!-- Card principal -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">

    <!-- Selector de cuenta -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px;">
        <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">account_balance</mat-icon>
        <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">Cuenta destino</span>
      </div>
      <mat-form-field appearance="outline" class="w-full modern-field" style="max-width: 320px;">
        <mat-label>Seleccionar Cuenta</mat-label>
        <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">business</mat-icon>
        <mat-select [(ngModel)]="selectedAccount" name="account" required>
          <mat-option *ngFor="let account of accounts" [value]="account">
            {{ account }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Zona de carga -->
    <div style="padding: 24px;">

      <!-- Drop zone -->
      <div style="border: 2px dashed; border-radius: 14px; padding: 32px 20px; text-align: center; transition: all 0.3s ease; position: relative;"
        [style.border-color]="isDragging ? '#1C593D' : (!selectedAccount ? '#e5e7eb' : '#bbf7d0')"
        [style.background]="isDragging ? '#f0fdf4' : (!selectedAccount ? '#f9fafb' : 'white')"
        [style.opacity]="!selectedAccount ? '0.6' : '1'"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">

        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".xls,.xlsx"
          [disabled]="isLoading || !selectedAccount"
          style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; opacity: 0; cursor: pointer;">

        <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #1C593D; opacity: 0.7;">cloud_upload</mat-icon>
        <p style="color: #374151; font-size: 0.95rem; font-weight: 600; margin: 8px 0 4px;">
          Arrastra y suelta tu archivo Excel aquí
        </p>
        <p style="color: #9ca3af; font-size: 0.8rem; margin: 0 0 12px;">o</p>
        <button type="button" (click)="fileInput.click()"
          [disabled]="isLoading || !selectedAccount"
          [style.opacity]="(isLoading || !selectedAccount) ? '0.5' : '1'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">folder_open</mat-icon>
          Seleccionar Archivo
        </button>
      </div>

      <!-- Requisitos -->
      <div style="display: flex; gap: 16px; justify-content: center; margin-top: 12px; flex-wrap: wrap;">
        <div style="display: flex; align-items: center; gap: 4px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">description</mat-icon>
          <span style="font-size: 0.75rem; color: #6b7280;">.xls, .xlsx</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">storage</mat-icon>
          <span style="font-size: 0.75rem; color: #6b7280;">Máx. 10MB</span>
        </div>
        <div style="display: flex; align-items: center; gap: 4px;">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">looks_one</mat-icon>
          <span style="font-size: 0.75rem; color: #6b7280;">Un archivo a la vez</span>
        </div>
      </div>

      <!-- Warning sin cuenta -->
      <div *ngIf="!selectedAccount" style="display: flex; align-items: center; gap: 8px; justify-content: center; margin-top: 12px;
        background: #fef3c7; padding: 8px 16px; border-radius: 10px; border: 1px solid #fde68a;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">warning</mat-icon>
        <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">Selecciona una cuenta primero para habilitar la carga.</span>
      </div>

      <!-- Archivo seleccionado -->
      <div *ngIf="selectedFileName"
        style="display: flex; align-items: center; gap: 10px; margin-top: 16px; padding: 12px 16px;
          background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
        <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">description</mat-icon>
        <div style="flex: 1; min-width: 0;">
          <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ selectedFileName }}
          </span>
          <span *ngIf="excelRecordCount !== null" style="font-size: 0.75rem; color: #6b7280;">
            {{ excelRecordCount }} registros encontrados
          </span>
        </div>
        <button (click)="clearFile()" [disabled]="isLoading"
          style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px;
            border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
        </button>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoading"
        style="display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 16px; padding: 12px;
          background: #f3f4f6; border-radius: 10px;">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <span style="font-size: 0.85rem; color: #6b7280; font-weight: 500;">Procesando archivo...</span>
      </div>

      <!-- Botón enviar -->
      <div style="display: flex; justify-content: center; margin-top: 20px;">
        <button type="button" (click)="onSubmit()" [disabled]="!canSubmit"
          [style.opacity]="!canSubmit ? '0.5' : '1'"
          [style.cursor]="!canSubmit ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">cloud_upload</mat-icon>
          {{ isLoading ? 'Procesando...' : 'Confirmar y Enviar' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Resultados -->
  <div *ngIf="uploadResponse" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <!-- Header resultados -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">assessment</mat-icon>
        <span style="font-size: 1.05rem; font-weight: 700; color: #1e5a3f;">Resultados de la Carga</span>
      </div>
    </div>

    <div style="padding: 20px 24px;">
      <!-- Grid de resultados -->
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
        <!-- Total -->
        <div style="background: #f3f4f6; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Total</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #374151; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.total }}
          </span>
        </div>
        <!-- Válidos -->
        <div style="background: #f0fdf4; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Válidos</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.valid }}
          </span>
        </div>
        <!-- Inválidos -->
        <div style="background: #fef2f2; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Inválidos</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #dc2626; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.invalid }}
          </span>
        </div>
        <!-- Exitosos -->
        <div style="background: #f0fdf4; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Exitosos</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #16a34a; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.procesados.success }}
          </span>
        </div>
        <!-- Duplicados -->
        <div style="background: #eff6ff; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Duplicados</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #2563eb; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.procesados.duplicados }}
          </span>
        </div>
        <!-- Fallidos -->
        <div style="background: #fef2f2; border-radius: 12px; padding: 14px; text-align: center;">
          <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Fallidos</span>
          <span style="font-size: 1.8rem; font-weight: 800; color: #dc2626; line-height: 1; display: block; margin-top: 4px;">
            {{ uploadResponse.procesados.failed }}
          </span>
        </div>
      </div>

      <!-- Botón cargar otro -->
      <div style="display: flex; justify-content: center;">
        <button type="button" (click)="clearFile()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
          Cargar Otro Archivo
        </button>
      </div>
    </div>
  </div>

</div>
